import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody } from 'reactstrap';
import DropdownIcon from '../icons/dropdownIcon';

const Dropdown = ({ label, value, handleClick }) => (
  <div className="dropdown" onClick={handleClick} role="button" aria-hidden>
    <Card className="card-border card-shadow border-0">
      <CardBody>
        <p>{label}</p>
        <div className="dropdown-body">
          <span>{value}</span>
          <DropdownIcon />
        </div>
      </CardBody>
    </Card>
  </div>
);

Dropdown.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  handleClick: PropTypes.func,
};

export default Dropdown;
